import { render } from "./SaleChip.vue?vue&type=template&id=35ac1800&scoped=true"
import script from "./SaleChip.vue?vue&type=script&lang=js"
export * from "./SaleChip.vue?vue&type=script&lang=js"

import "./SaleChip.vue?vue&type=style&index=0&id=35ac1800&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ac1800"]])

export default __exports__